// extracted by mini-css-extract-plugin
export var columnList = "_bg-0";